import fetchJsonp from './jsonp';
import axios from 'axios';

export function writeOembedResult({ element, oembedResponse, dataAttributes }) {
  if (oembedResponse.html) {
    const cacheElement = element.querySelector('[data-cache]');
    cacheElement.innerHTML = oembedResponse.html;
    const oembedEl = cacheElement.firstElementChild;

    if (dataAttributes) {
      Object.keys(dataAttributes).forEach((attr) => {
        oembedEl.setAttribute(`data-${attr}`, dataAttributes[attr]);
      });
    }
    return cacheElement;
  }
}

function createEmbedElement(html) {
  const container = document.createElement('div');
  container.innerHTML = html;
  return container;
}

export const fetchOembedJsonP = async ({ url, params = {}}) => {
  const urlParams = new URLSearchParams({
    format: 'json',
    ...params
  });
  const requestUrl = url + '?' + urlParams.toString();
  const response = await fetchJsonp(requestUrl);
  const data = await response.json();

  return data;
};

export const fetchOembed = async ({ url, params = {}}) => {
  const response = await axios.get(url, {
    params: {
      format: 'json',
      ...params
    }
  });
  return response.data;
};
